import { render, staticRenderFns } from "./PackageFile.vue?vue&type=template&id=02f37a72&scoped=true&"
import script from "./PackageFile.vue?vue&type=script&lang=js&"
export * from "./PackageFile.vue?vue&type=script&lang=js&"
import style0 from "./PackageFile.vue?vue&type=style&index=0&id=02f37a72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f37a72",
  null
  
)

export default component.exports